import { Reveal } from "../components/Reveal";
import { IMG } from "../data/images";
import { useLang } from "../i18n";

const SPANS = ["sm:col-span-2 sm:row-span-2", "", "sm:row-span-2", "", "", "", "sm:col-span-2"];

export const Gallery = () => {
  const { t } = useLang();

  return (
    <section id="galeria" data-testid="gallery-section" className="relative bg-[#2B1E16] px-6 py-24 md:px-12 md:py-40">
      <div className="grain absolute inset-0" />
      <div className="relative mx-auto max-w-[1400px]">
        <Reveal>
          <p className="label text-[#D9B98A]">{t.gallery.label}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 max-w-[20ch] font-serif text-4xl font-light leading-[1.06] text-[#F5EDE3] sm:text-5xl lg:text-6xl">
            {t.gallery.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-flow-dense auto-rows-[190px] grid-cols-2 gap-2 sm:auto-rows-[220px] sm:grid-cols-4 md:mt-24 md:gap-3 lg:auto-rows-[260px]">
          {IMG.gallery.map((g, i) => (
            <div
              key={g.name}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden bg-[#F5EDE3]/5 ${g.span ?? SPANS[i % SPANS.length]}`}
            >
              <img
                src={g.src}
                alt={g.alt}
                data-placeholder-name={g.name}
                loading="lazy"
                className="h-full w-full object-cover opacity-90 transition-all duration-[2000ms] ease-out group-hover:scale-[1.08] group-hover:opacity-100"
              />
              <div className="pointer-events-none absolute inset-0 border border-[#D9B98A]/0 transition-colors duration-500 group-hover:border-[#D9B98A]/40" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
